(function($){
    'use strict';

    var $inputBox  = $('.search__input');
    let mapData = {
        map: null,
        markers: [],
        routeGroup: null,
        routeCache: [],
        points: [],
        center: [],
        bounds: [],
        electoraterating: '',
        apiKey: 'caad8f7d2a7d4da98cb2bd888cbf8a27'
    }

    const suburbSearch = {
        sel: {
            search: '#search__suburb-autocomplete',
            searchMenu: '.suburb-search'
        },
        vars: {
            classNames: 'search__input',
            url: $inputBox.attr('data-typeahead') + '?partial_query=',
            wideBreakpoint: 1024,
            viewAll: 'View all results',
            keys: {
                ENTER: 13
            }
        },
        init() {
            this.initTypehead();
            // this.setAutosuggestionWidth();
            this.sendQuery();
        },
        initTypehead() {
            const self = this;
            $(this.sel.search).typeahead({
                name: 'suburb-search',
                hint: true,
                highlight: true,
                minLength: 3,
                classNames: {
                    input: self.vars.classNames + '--input',
                    hint: self.vars.classNames + '--hint',
                    menu: self.vars.classNames + '--menu',
                    dataset: self.vars.classNames + '--dataset',
                    suggestion: self.vars.classNames + '--suggestion',
                    empty: self.vars.classNames + '--empty',
                    open: self.vars.classNames + '--open',
                    cursor: self.vars.classNames + '--cursor',
                    highlight: self.vars.classNames + '--highlight',
                    selectable: self.vars.classNames + '--selectable'
                }
            },
            {
                name: 'data',
                async: true,
                limit: 10,
                source: function(query, sync, async) {
                    self.findMatches(query, async)
                },
                display: function(item){
                  return item.suburb + ', ' + item.postcode;
                },
                templates: {
                  empty: [
      '<div class="empty-message">',
        'unable to find any Best Picture winners that match the current query',
      '</div>'
    ].join('\n'),
                    suggestion: function(data) {
                        return `<div data-latlng="${data.latitude},${data.longitude}" 
                        data-electoraterating="${data.electoraterating.toLowerCase()}"
                        data-postcode="${data.postcode}"
                        data-suburb="${data.suburb}">
                        ${data.suburb}, ${data.postcode}</div>`;
                    }
                }
            });
        },
        findMatches(query, cb) {
          const self = this;
          var matches = [],
              url = self.vars.url,
              storedSuburbsVal = $(self.sel.savedSuburbs).val(),
              currentStoredSuburbs = [],
              querySting = query.toLowerCase(),
              noResults = '<div class="no-result-text">No matches. Search again</div>',
              dataset = $('.search__input--dataset');

              // Add stored suburbs into array
              if(storedSuburbsVal) {
                currentStoredSuburbs = storedSuburbsVal.split(';');
              }

              fetch(url)
                  .then(res => res.json())
                  .then((res) => {
                      for(var i = res.length - 1; i >= 0; i--) {
                          var rawCat = res[i].suburb,
                              resCat = rawCat.toLowerCase(),
                              rawRelated = res[i].postcode,
                              resRelated = rawRelated.toString(),
                              storedSuburbStr = rawCat + ', ' + rawRelated,
                              suburbLatLng = res[i].latitude + ',' + res[i].longitude;

                          // Remove items from results if no match or if its already saved
                          if (resCat.indexOf(querySting) === -1 && resRelated.indexOf(querySting) === -1 && storedSuburbStr.toLowerCase().indexOf(querySting) === -1) {
                              res.splice(i, 1);
                          }


                      }
                      cb(res);

                      // No results. Plugin no results not working
                      if(!res.length) {
                          dataset.html(noResults);
                          $('.search__input--menu').css('display', 'block');
                      }
                  }
              );
        },
        setAutosuggestionWidth() {
            if (window.innerWidth < this.vars.wideBreakpoint) {
                $(this.sel.searchMenu).css({
                    'width': $(this.sel.search).width() + 'px',
                    'left': '-24px'
                });
            }
        },
        sendQuery() {
            const self = this;

            // Custom select event
            $(this.sel.search).bind('typeahead:select', function(e, suggestion) {
                $(self.sel.add).prop('disabled', false);
                $(this).typeahead('close');
                $(this).val(suggestion.suburb + ', ' + suggestion.postcode);
                
                let data = $(this).data();
                let options = { 
                    latlng: suggestion.latitude + ',' + suggestion.longitude, 
                    electoraterating: suggestion.electoraterating,
                    postcode: suggestion.postcode,
                    suburb: suggestion.suburb
                };
                Object.assign(data, options);
                
                /*
                $(this).data('latlng', suggestion.latitude + ',' + suggestion.longitude);
                $(this).data('electoraterating', suggestion.electoraterating);*/

                submitSearchLatLng(data);
            });

            // Enter keystroke event
            $(this.sel.search).on('keyup', function(e) {
                const key = e.which;
                if (key === self.vars.keys.ENTER) {
                    let data = $(this).data();
                    let options = { 
                        latlng: suggestion.latitude + ',' + suggestion.longitude, 
                        electoraterating: suggestion.electoraterating,
                        postcode: suggestion.postcode,
                        suburb: suggestion.suburb
                    };
                    Object.assign(data, options);
                    submitSearchLatLng(data);
                }
            });

            $('.suburb-search').on('submit', () => {
                return false;
            });

            // Add name query to input field for accessibility
            $('.search__input--hint').attr({
                'name': 'suburb-hint',
                'title': 'Suburb Hint'
            });
        }
    };

    // Initiate on step three
    if(document.querySelector('.my-current-location') && document.querySelector('.suburb-search-wrapper')) {
        getLocation();
        suburbSearch.init();
    }


    // Location check
    var myLocationNote = document.querySelector(".my-current-location-note");

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(removeNote, showError);
        } else {
            myLocationNote.innerHTML = "Geolocation is not supported by this browser.";
        }

        // init search
        if(getParameterByName('postcode') != 'null') {
            let qs = getParameterByName('location');
            if(qs) {
                qs = qs.split(',');
                let latlng = getParameterByName('latlng');
                $(suburbSearch.sel.search).val(`${qs[0]}, ${qs[1]}`);

                let data = {
                    latlng: latlng,
                    suburb: qs[0],
                    postcode: qs[1],
                    electoraterating: qs[2]
                };
                if(qs.length === 3 && latlng) submitSearchLatLng(data);
            }
        }
    }

    function removeNote(position) {
        let myCurrentLocation = document.querySelector('.my-current-location'),
            latLonPosition = position.coords.latitude + ',' + position.coords.longitude;
 
        // Remove notice and enable
        $(myLocationNote).remove();
        myCurrentLocation.value = latLonPosition;
        myCurrentLocation.disabled = false;
        //myCurrentLocation.checked = true;
        
        // if searching by geolocation
        if(getParameterByName('postcode') === 'null') {
            myCurrentLocation.checked = true;
            mapData.center = latLonPosition.split(',');
            submitSearchLatLng({ latlng: myCurrentLocation.value });
        } 
    }

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function showError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          myLocationNote.innerHTML = "Location tracking permission was denied. To use My current location, you'll need to clear your location settings in your browesr."
          break;
        case error.POSITION_UNAVAILABLE:
          myLocationNote.innerHTML = "Location information is unavailable."
          break;
        case error.TIMEOUT:
          myLocationNote.innerHTML = "The request to get user location timed out. Please refresh the page to accept location tracking"
          break;
        case error.UNKNOWN_ERROR:
          myLocationNote.innerHTML = "An unknown error occurred."
          break;
      }
    }

    const getRoute = (to) => {
        const center = mapData.center.length ? mapData.center : mapData.points[0].latlng;
        const url = `https://api.geoapify.com/v1/routing?waypoints=${center.join(',')}|${to.join(',')}&mode=drive&details=instruction_details&apiKey=${mapData.apiKey}`;
        if(mapData.routeGroup) mapData.routeGroup.clearLayers();

        const renderRoute = (data) => {
            setTimeout(function(){ 
                mapData.routeGroup = L.geoJSON(data, {
                    style: (feature) => {
                      return {
                        color: "rgba(20, 137, 255, 0.7)",
                        weight: 5
                      };
                    }
                }).addTo(mapData.map);
             },500);
        }

        // in memory cache;
        const key = to.join(',') + center.join(',');
        if(typeof(mapData.routeCache[key]) !== "undefined") {
            renderRoute(mapData.routeCache[key]);
        } else {
            // API query routes
            $.get(url, (data) => {
                mapData.routeCache[key] = data;
                renderRoute(data);
            });
        }
    }

    const initLeafletMap = () => {

        let circleMarker;
         // The Leaflet map Object

        let e = document.getElementById('map');
        if(e) e.style = 'display:block';

        let zoomLevels = [];
        for(let x = 0, d = 2; x < 17; x++) {
            if(x < 7) zoomLevels[x] = 0;
            else {
                zoomLevels[x] = d;
                d += d;
            }
        }
        let zoom, circleRadius;
        switch(mapData.electoraterating.toLowerCase()) {
            case 'rural': zoom = 10; break;
            case 'provincial': zoom = 11; break;
            case 'outer metropolitan': zoom = 12; break;
            case 'inner metropolitan': zoom = 11;  break;
            default: zoom = 10; break;
        }
        circleRadius = zoomLevels[zoom];
        mapData.points.forEach(p => {
            if(p.latlng) {
                var icon = L.icon({
                    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${p.class}.png`,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowUrl: `https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png`,
                    shadowSize: [41, 41] 
                });
                if(p.class === 'bluedot') {
                    circleMarker = L.circleMarker(p.latlng, {radius: circleRadius, color: 'blue'});
                    circleMarker.bindPopup('My current location').on('popupopen', function(e) {
                        getRoute(p.latlng);
                    })
                } else if(p.class === 'greendot') {
                    circleMarker = L.circleMarker(p.latlng, { radius: circleRadius, color: 'green'})
                    //circleMarker.bindPopup('Your particular suburb');
                } else {
                    let marker = L.marker(p.latlng,  {icon: icon});
                    marker.bindPopup(p.html.join('<br />')).on('popupopen', function(e) {
                        getRoute(p.latlng);
                    })
                    mapData.markers.push(marker);
                    mapData.bounds.push(p.latlng);
                }
            }
        })

        const center = mapData.center.length ? mapData.center : mapData.points[0].latlng;
        if(!mapData.map) mapData.map = L.map('map', {         
            maxZoom: 15,
            minZoom: 7
        });
        mapData.map.setView(center, zoom);

        // Retina displays require different mat tiles quality
        const isRetina = L.Browser.retina;
        
        const baseUrl = `https://maps.geoapify.com/v1/tile/osm-bright/{z}/{x}/{y}.png?apiKey=${mapData.apiKey}`;
        const retinaUrl = `https://maps.geoapify.com/v1/tile/osm-bright/{z}/{x}/{y}@2x.png?apiKey=${mapData.apiKey}`;
    
        // Add map tiles layer. Set 20 as the maximal zoom and provide map data attribution.
        L.tileLayer(isRetina ? retinaUrl : baseUrl, {
        //attribution: 'Powered by <a href="https://www.geoapify.com/" target="_blank">Geoapify</a> | <a href="https://openmaptiles.org/" rel="nofollow" target="_blank">(c) OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright" rel="nofollow" target="_blank">(c) OpenStreetMap</a> contributors',
            apiKey: mapData.apiKey,
            id: 'osm-bright'
        }).addTo(mapData.map);

        L.featureGroup(mapData.markers).addTo(mapData.map);
        if(typeof(circleMarker) !== "undefined") circleMarker.addTo(mapData.map).openPopup();

        mapData.map.on("zoomend", () => {
            mapData.map.eachLayer(layer => {
                if(typeof(layer.options) !== "undefined")
                    if(typeof(layer.options.color) !== "undefined" && typeof(layer.options.radius) !== "undefined") {
                        layer.setRadius(zoomLevels[mapData.map.getZoom()]);
                    }
            });
        })

    }
    function parseIsOpen(string = null) {

        let oc = ['','']

        // open 247
        if(string === '247') 
        return {
            hours: `24/7`,
            isOpen: true
        }
      
        if(string) {
            const date = new Date();
            let day = date.getDate();
            let month = date.getMonth();
            let year = date.getFullYear();
            let hours = date.getHours();
            let minutes = date.getMinutes();
            const nowTs = new Date(year,month,day,hours,minutes).getTime();
            let openTs = nowTs, closedTs = nowTs;
            oc = string.split('|');

            let tm = oc[0].split(':');
            if(oc[0]) {
                if(tm[0] && tm[1]) openTs = new Date(year,month,day,tm[0],tm[1]).getTime();
            }
            if(oc[1]) {
                tm = oc[1].split(':');
                if(tm[0] && tm[1]) closedTs = new Date(year,month,day,tm[0],tm[1]).getTime();
            }
            if(nowTs > openTs && nowTs < closedTs) {  // is open
                return {
                    hours: `${oc[0]} - ${oc[1]}`,
                    isOpen: true
                }
            }
        }
        // not open
        return {
            hours: `${oc[0]} - ${oc[1]}`,
            isOpen: false
        }
    }

    function parseLatLng(center) {

        // add green dot to center 
        if(center) mapData.points.push({
            html: null,
            latlng: mapData.center,
            class: 'greendot'
        });

        let items = $('.contact-item');
        if(items.length) {
            $.each(items, (index, i) => {
                try {
                    
                    const data = $(i).data();
                    const open = parseIsOpen(data.hours);

                    let name,address,phone,distance,route;
                    let html = [];
                    if(name = $(i).find('.contact-name').html()) html.push(`<strong data-rank="${data.rank}">${name}</strong>`)
                    if(address = $(i).find('.contact-address').parent().html()) html.push(address)
                    if(phone = $(i).find('.contact-number').parent().html()) html.push(phone)
                    
                    let ostring;
                    if(open.hours) ostring = `Hours: ${open.hours}`
                    ostring += open.isOpen ? ' (Open)' : ' (Closed)'
                    html.push(ostring);

                    if(distance = $(i).find('.contact-distance').parent().html()) html.push(distance)

                    // update html element
                    let isOpenElm = $(i).find('.isOpen')
                    if(isOpenElm) isOpenElm.html(open.isOpen ? ' (Open)' : ' (Closed)')

                    if(data.latlng) {
                        const point = {
                            html: html,
                            latlng: typeof(data.latlng) != "undefined" ? data.latlng.toString().split(',') : null,
                            class: open.isOpen ? data.icon : "grey"
                        };
               
                        if(point.latlng) mapData.points.push(point)
                    }
                } catch(e) { console.log(e) }
            })
        }

        // push a marker for my current location onto the map (render blue dot)
        let myCurrentLocation = document.querySelector('.my-current-location');
        const ll = myCurrentLocation.value;
        if(myCurrentLocation.checked === true) {
            const point = {
                html: ['Your particular suburb'],
                latlng: typeof(ll) != "undefined" ? ll.toString().split(',') : null,
                class: 'bluedot'
            };
            mapData.points.push(point)
        }
        if(mapData.points.length) initLeafletMap()
    }

   /* function submitSearch(newPostcode) {
        let domainStr = window.location.href.split('?')[0],
            animalId = getParameterByName('animal'),
            animalCondition = getParameterByName('animal-condition'),
            // postCode = getParameterByName('postcode'),
            resultsPageUrl = document.querySelector('.suburb-search'),
            newResultsUrl = resultsPageUrl.getAttribute('action') + '?animal=' + animalId + '&animal-condition=' + animalCondition + '&postcode=' + newPostcode,
            newHistoryUrl = domainStr + '?animal=' + animalId + '&animal-condition=' + animalCondition + '&postcode=' + newPostcode,
            resultsEl = document.querySelector('.contact-results'),
            loadingAnimation = '<div class="sp sp-circle"></div>';

            resultsEl.innerHTML = '';
            resultsEl.innerHTML += loadingAnimation;

            $.get(newResultsUrl, (data) => {
                resultsEl.innerHTML = '';
                resultsEl.innerHTML += data;
            });

            history.pushState({postcode: newPostcode}, newPostcode + ' Postcode search', newHistoryUrl);
    }
*/
    function submitSearchLatLng(data = { suburb: null, postcode: null, electoraterating: '', latlng: null}) {
        
        const { suburb,postcode,electoraterating,latlng } = data;

        if(!latlng) {
            console.log('error: submitSearchLatLng latlng = null');
            return; 
        }

        mapData.center = latlng.split(',');
        mapData.electoraterating = electoraterating;
        let location = `${suburb},${postcode},${electoraterating}`;

        let domainStr = window.location.href.split('?')[0],
            animalId = getParameterByName('animal'),
            animalCondition = getParameterByName('animal-condition'),
            // postCode = getParameterByName('postcode'),
            resultsPageUrl = document.querySelector('.suburb-search'),
            newResultsUrl = resultsPageUrl.getAttribute('action') + '?animal=' + animalId + '&animal-condition=' + animalCondition + '&type=latlng&value=' + latlng,
            newHistoryUrl = domainStr + '?animal=' + animalId + '&animal-condition=' + animalCondition + '&latlng=' + latlng + '&location=' + location,
            resultsEl = document.querySelector('.contact-results'),
            loadingAnimation = '<div class="sp sp-circle"></div>';

            resultsEl.innerHTML = '';
            resultsEl.innerHTML += loadingAnimation;

            $.get(newResultsUrl, (data) => {
                resultsEl.innerHTML = '';
                resultsEl.innerHTML += data;

                // reset map
                if(mapData.map) {
                    mapData.map.off();
                    mapData.map.remove();
                    mapData.map = null;
                }

                mapData.markers = [],
                mapData.points = [],
                mapData.bounds = [];

                parseLatLng(postcode ? mapData.center : null);
            });

            history.pushState({latlng: latlng, postcode: postcode}, postcode + ' Postcode search', newHistoryUrl);
    }

    // open and panto a marker
    function panToPopup(marker) {
        marker.openPopup();
        mapData.map.panTo(marker._latlng);
    }

    // View on map button
    $('.contact-results').on('click','.view-on-gm',(e) => {
        e.preventDefault();
        let rank = $(e.target).parent().parent().data('rank');
        if(typeof(rank) !== "undefined") {
            const marker = mapData.markers.find(f => { 
                return f._popup._content.indexOf(`data-rank="${rank}"`) > -1
            });
            if(typeof(marker) !== "undefined") {
                $('html, body').animate({
                    scrollTop: $(".map-container").offset().top
                }, 250);
                panToPopup(marker); 
            } 
        }
    });

    // Show or hide suburb search
    $('.suburb-search input:radio').on('change', (e) => {
        onRadioChange(e.target.value, e.target.classList);
    });

    const onRadioChange = (val, classes) => {

        const data = {
            latlng: null,
            electoraterating: '',
            postcode: null,
            suburb: null
        }

        let suburbWrapper = document.querySelector('.suburb-search-wrapper'),
            myCurrentLocationSelected = false;

        // check which radio is selected
        for(let eachClass of classes) {
            if(eachClass == 'my-current-location') {
                myCurrentLocationSelected = true;
            }
        }

        // Show or hide suburb search
        if(myCurrentLocationSelected) {
            suburbWrapper.classList.add('hide');

            // If current location results already being shown, submit search
            data.latlng = val;
            submitSearchLatLng(data);
        }
        else {
            val = $(suburbSearch.sel.search).data();
            if(val) {
                const data = {
                    latlng: val.latlng,
                    electoraterating: val.electoraterating,
                    postcode: val.postcode,
                    suburb: val.suburb
                }
                submitSearchLatLng(data);
                suburbWrapper.classList.remove('hide');
            }
        }

    }



}(jQuery));
